import { api } from "@shared/api/client";
import type {
  Iso2700127701DocumentoSistema,
  Iso2700127701DocumentoSistemaPayload,
  Iso2700127701DocumentosSistemaFilters,
  Iso2700127701DocumentosSistemaResponse,
} from "../../../types/iso2700127701";
import type {
  Iso2700127701ControlModificacion,
  Iso2700127701ControlModificacionPayload,
} from "../../../types/control-modificaciones";

const BASE_URL = "/certificaciones/iso-27001-27701/documentos-sistema";

export async function getIso2700127701DocumentosSistema(filters: Iso2700127701DocumentosSistemaFilters, signal?: AbortSignal) {
  const { data } = await api.get<Iso2700127701DocumentosSistemaResponse>(BASE_URL, {
    params: Object.fromEntries(Object.entries(filters).filter(([, value]) => value !== "")),
    signal,
  });
  return data;
}

export async function createIso2700127701DocumentoSistema(payload: Iso2700127701DocumentoSistemaPayload) {
  const { data } = await api.post<{ ok: boolean; data: Iso2700127701DocumentoSistema }>(BASE_URL, payload);
  return data.data;
}

export async function updateIso2700127701DocumentoSistema(id: number, payload: Iso2700127701DocumentoSistemaPayload) {
  const { data } = await api.put<{ ok: boolean; data: Iso2700127701DocumentoSistema }>(`${BASE_URL}/${id}`, payload);
  return data.data;
}

export async function deleteIso2700127701DocumentoSistema(id: number) {
  await api.delete(`${BASE_URL}/${id}`);
}

export async function createIso2700127701DocumentoControlModificacion(payload: Iso2700127701ControlModificacionPayload) {
  const { data } = await api.post<{ ok: boolean; data: Iso2700127701ControlModificacion }>(`${BASE_URL}/control-modificaciones`, payload);
  return data.data;
}

export async function updateIso2700127701DocumentoControlModificacion(id: number, payload: Iso2700127701ControlModificacionPayload) {
  const { data } = await api.put<{ ok: boolean; data: Iso2700127701ControlModificacion }>(`${BASE_URL}/control-modificaciones/${id}`, payload);
  return data.data;
}

export async function deleteIso2700127701DocumentoControlModificacion(id: number) {
  await api.delete(`${BASE_URL}/control-modificaciones/${id}`);
}
